import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    title: {},

    appBar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: theme.spacing(2),
      marginTop: theme.spacing(4)
    },
    multiColumns: {
      display: 'flex',
      alignItems: 'stretch',
      //minHeight: 'calc(100vh - 48px)',
      flexWrap: 'wrap-reverse'
    },
    leftColumn: {
      flexGrow: 1,
      marginRight: theme.spacing(2)
    },
    leftCard: {
      minHeight: '350px',
      maxHeight: '350px',
      height: '350px'
    },
    rightColumn: {
      flexGrow: 1
    },
    rightCard: {
      minHeight: '350px',
      maxHeight: '350px',
      height: '350px',
      overflow: 'auto'
    },
    break: {
      flexBasis: '100%'
    },
    content: {
      padding: theme.spacing(3)
    },
    dropZone: {
      minHeight: '150px',
      height: '150px'
    },
    previewChip: {
      minWidth: 160,
      maxWidth: 210
    },
    cardHeight: {
      height: '100%'
    }
  });
